export const convertStringToNumber = (text, fallback) => {
    const n = Number(text);
    return isNaN(n)
        ? fallback
        : n;
};
